import { createSlice }        from '@reduxjs/toolkit';
import * as organizerReducers from 'Redux/Reducers/Organizer';
import { Organizer }          from 'Domain/Models';

export interface IOrganizerState {
  openRequests: string[],
  failedRequests: string[],
  updatedAt: number,
  entries: Record<string, Organizer>,
  searchEntries: Record<string, Organizer>,
  lastUpdateId: string|null,
  maxCount: number,
}

export const organizerSlice = createSlice({
  name: 'organizer',
  initialState: {
    openRequests: [],
    failedRequests: [],
    entries: {},
    searchEntries: {},
    maxCount: 0,
    lastUpdateId: null,
    updatedAt: 0,
  },
  reducers: organizerReducers,
});
